import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ENTERPRISE_ADMIN_BASE } from '../../config/adminLayers';

const BASE = `${ENTERPRISE_ADMIN_BASE}/operations`;

const TABS = [
  { label: 'Dashboard', to: BASE },
  { label: 'Worker plane', to: `${BASE}/workers` },
  { label: 'Queues', to: `${BASE}/queues` },
  { label: 'Policies & SLOs', to: `${BASE}/policies` },
  { label: 'Runtime', to: `${BASE}/runtime` },
  { label: 'Migration', to: `${BASE}/migration` },
  { label: 'History', to: `${BASE}/history` },
];

export const OperationsCenterLayout: React.FC = () => {
  const tabClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
      isActive
        ? 'bg-enterprise-accent/15 text-enterprise-accent'
        : 'text-enterprise-600 hover:bg-enterprise-100 hover:text-enterprise-900'
    }`;

  return (
    <div className="mx-auto max-w-7xl space-y-6">
      <div className="rounded-2xl border border-enterprise-200 bg-white p-6 shadow-sm">
        <p className="text-xs font-bold uppercase tracking-widest text-emerald-600">Platform operations</p>
        <h1 className="mt-2 text-2xl font-bold text-enterprise-900">Enterprise Operations Center</h1>
        <p className="mt-2 max-w-3xl text-sm text-enterprise-600">
          Configuration-driven execution plane. Runtime behavior is unchanged until Phase 4 flags and queue migration
          are enabled. All controls are audit-logged when database config is active.
        </p>
        <nav className="mt-4 flex flex-wrap gap-2 border-t border-enterprise-100 pt-4">
          {TABS.map((t) => (
            <NavLink key={t.to} to={t.to} end={t.to === BASE} className={tabClass}>
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
};
